import { createBrowserRouter, Outlet, RouterProvider } from 'react-router-dom';
import React from 'react';
import { Footer, Header } from './components';
import ScrollToTop from './context/scrollToTopContext';

const Home = React.lazy(() => import('./pages/home'));
const About = React.lazy(() => import('./pages/about'));
const Gallery = React.lazy(() => import('./pages/gallery'));
const Contact = React.lazy(() => import('./pages/contact'));
const Services = React.lazy(() => import('./pages/services'));
const ServicesSingle = React.lazy(() => import('./pages/services-single'));

const App = () => {
  const routes = createBrowserRouter([
    {
      path: '/',
      element: (
        <>
          <Header />
          <ScrollToTop />
          <Outlet />
          <Footer />
        </>
      ),
      children: [
        { path: '/', element: <Home /> },
        { path: '/services', element: <Services /> },
        { path: '/contact', element: <Contact /> },
        { path: '/gallery', element: <Gallery /> },
        { path: '/services/:id', element: <ServicesSingle /> },
        { path: '/about', element: <About /> },
      ],
    },
  ]);

  return <RouterProvider router={routes} />;
};

export default App;
